"use client";

import Image from "next/image";
import { motion, Variants, AnimatePresence } from "framer-motion";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faPlus } from "@fortawesome/pro-light-svg-icons";

const textBlockVariants: Variants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1.0, // 지속 시간 증가 (부드러움 증가)
      // Custom Bezier Curve (더 세련된 모션)
      ease: [0.17, 0.55, 0.55, 1],
    },
  },
};
export function DataInfo() {
  const [openIndex, setOpenIndex] = useState(0);

  const items = [
    {
      id: 1,
      title: "수집",
      content:
        "장애 커뮤니티와 협력하여, 프로그램 운영과 활동가 양성을 통해 이동정보를 수집합니다.",
    },
    {
      id: 2,
      title: "데이터 정리",
      content: "수집된 이동정보를 체계적으로 정리하고 분석합니다.",
    },
    {
      id: 3,
      title: "정보 가공",
      content: "정리된 데이터를 위맵, 키오스크 등 다양한 형태로 가공합니다.",
    },
    {
      id: 4,
      title: "정보 제공",
      content:
        "가공된 정보를 장애인뿐만 아니라 모두에게 쉽게 제공하여 접근성을 높입니다.",
    },
  ];

  const toggleItem = (index: number) => {
    setOpenIndex((prev) => (prev === index ? -1 : index));
  };
  return (
    <div className="bg-[#F5F4F2] py-40 px-5 xl:px-0 rounded-4xl">
      <motion.div
        className="w-full xl:max-w-[1280px] xl:px-0 mx-auto"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.5 }}
      >
        <motion.div variants={textBlockVariants}>
          <p
            className="md:text-2xl text-[15px] text-lightGray-20 mb-2 md:mb-6 tracking-tight"
            style={{ fontFamily: '"paperlogy-bold", sans-serif' }}
          >
            Our Mission
          </p>
          <p
            className="md:text-5xl text-xl text-black-almostBlack tracking-tight md:leading-18  leading-8"
            style={{ fontFamily: '"pre-SemiBold", sans-serif' }}
          >
            교통약자의 이동정보를 수집하고,
            <br />
            다양한 형태로 정보를 제공합니다.
          </p>
        </motion.div>
        <div className="flex-col-reverse flex lg:flex-row justify-between items-stretch mt-10 md:mt-20">
          <ul className="divide-y divide-gray-300 w-full flex-1 mr-10 lg:mr-20 border-b-[1.8px] border-t-[1.8px] border-midGray-30">
            {items.map((item, i) => {
              const isOpen = openIndex === i;
              return (
                <li
                  key={item.id}
                  className={`py-6 md:py-10 px-2 ${
                    i !== items.length - 1
                      ? "border-b-[1.8px] border-midGray-30"
                      : ""
                  }`}
                >
                  <button
                    onClick={() => toggleItem(i)}
                    className="w-full flex justify-between items-center text-left"
                  >
                    <div className="flex items-center">
                      <p className="semibold-text-32 text-md-18 w-9 md:w-14 flex flex-col">
                        {String(i + 1).padStart(2, "0")}
                      </p>
                      <span className="semibold-text-32 text-md-18">
                        {item.title}
                      </span>
                    </div>

                    <div className="w-4 h-4 md:w-7 md:h-7">
                      <FontAwesomeIcon
                        icon={isOpen ? faMinus : faPlus}
                        color="var(--color-black-200)"
                        className="text-lg md:text-2xl"
                      />
                    </div>
                  </button>

                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        key="content"
                        initial="collapsed"
                        animate="open"
                        exit="collapsed"
                        variants={{
                          open: { height: "auto", opacity: 1 },
                          collapsed: { height: 0, opacity: 0 },
                        }}
                        transition={{
                          duration: 0.4,
                          ease: [0.4, 0, 0.2, 1],
                        }}
                        className="overflow-hidden text-gray-600 text-sm mt-2"
                      >
                        <p className="regular-text-20  text-md-15 py-2">
                          {item.content}
                        </p>{" "}
                      </motion.div>
                    )}
                  </AnimatePresence>
                </li>
              );
            })}
          </ul>
          {/* 이미지 컨테이너 */}
          <motion.div
            transition={{ duration: 0.5, ease: [0.25, 0.1, 0.25, 1] }}
            className="relative w-full h-[180px] lg:h-auto lg:w-[480px] flex-shrink-0 self-stretch rounded-md overflow-hidden mb-10 lg:mb-0"
          >
            <Image
              src="/assets/images/page/main/datainfoImage.jpg"
              alt="backgroundIMG"
              fill
              className="object-cover lg:object-cover"
              priority
            />
          </motion.div>
        </div>
      </motion.div>
    </div>
  );
}
